import React from 'react';
import Container from "@cloudscape-design/components/container";
import Header from "@cloudscape-design/components/header";
import SpaceBetween from "@cloudscape-design/components/space-between";
import FormField from "@cloudscape-design/components/form-field";
import Input from "@cloudscape-design/components/input";
import Select from "@cloudscape-design/components/select";
import Button from "@cloudscape-design/components/button";
import {parameterTypeOptions,  ApiConfig } from './types';

interface APIParametersSectionProps {
    formData: ApiConfig;
    setFormData: (data: ApiConfig) => void;
}

const RequiredField = ({ label }: { label: string }) => (
    <label>
        {label}
        <span style={{ color: "red", marginLeft: "4px" }}>*</span>
    </label>
);

const APIParametersSection: React.FC<APIParametersSectionProps> = ({
                                                                       formData,
                                                                       setFormData
                                                                   }) => {
    return (
        <Container header={<Header variant="h2">API Parameters</Header>}>
            <SpaceBetween direction="vertical" size="l">
                <FormField label={<RequiredField label="HTTP Method" />}>

                    <Select
                        selectedOption={formData.httpMethod}
                        onChange={({detail}) => setFormData({...formData, httpMethod: detail.selectedOption})}
                        options={[
                            {label: "POST", value: "post"},
                            {label: "GET", value: "get"},
                            {label: "CREATE", value: "create"},
                            {label: "PUT", value: "put"},
                            {label: "PATCH", value: "patch"},
                            {label: "DELETE", value: "delete"},
                        ]}
                        placeholder="Select Method"
                    />
                </FormField>


                <FormField label="Required Parameters">
                    <Button
                        iconName="add-plus"
                        variant="icon"
                        onClick={() => setFormData({...formData, requiredParameters:[...formData.requiredParameters, {name: "", type: "header"}]})} // Initialize with "header"
                    />
                    {formData.requiredParameters.map((param, index) => (
                        <SpaceBetween direction="horizontal" size="xs" key={index}>
                            <Input
                                placeholder="Name"
                                value={param.name}
                                onChange={({detail}) => {
                                    const newParams = [...formData.requiredParameters];
                                    newParams[index].name = detail.value;
                                    setFormData({...formData, requiredParameters: newParams});
                                }}
                            />
                            <Select
                                placeholder="Type of Parameter"
                                selectedOption={{ label: param.type, value: param.type }}
                                options={parameterTypeOptions}
                                onChange={({detail}) => {
                                    const newParams = [...formData.requiredParameters];
                                    newParams[index].type = detail.selectedOption.value as "header" | "query" | "path";
                                    setFormData({...formData, requiredParameters: newParams});
                                }}
                            />
                            {formData.requiredParameters.length > 0 && (
                                <Button
                                    iconName="remove"
                                    ariaLabel="remove-required"
                                    variant="icon"
                                    onClick={() => {
                                        const newParams = [...formData.requiredParameters];
                                        newParams.splice(index, 1);
                                        setFormData({...formData, requiredParameters:newParams});
                                    }}
                                />
                            )}
                        </SpaceBetween>
                    ))}
                </FormField>

                <FormField label="Optional Parameters">
                    <Button
                        iconName="add-plus"
                        variant="icon"
                        ariaLabel="Add optional parameter"
                        onClick={() => setFormData({...formData, optionalParameters:[...formData.optionalParameters, {name: "", type: "header"}]})} // Initialize with "header"
                    />
                    {formData.optionalParameters.map((param, index) => (
                        <SpaceBetween direction="horizontal" size="xs" key={index}>
                            <Input
                                placeholder="Name"
                                value={param.name}
                                onChange={({detail}) => {
                                    const newParams = [...formData.optionalParameters];
                                    newParams[index].name = detail.value;
                                    setFormData({...formData, optionalParameters: newParams});
                                }}
                            />
                            <Select
                                placeholder="Type of Parameter"
                                selectedOption={{ label: param.type, value: param.type }}
                                options={parameterTypeOptions}
                                onChange={({detail}) => {
                                    const newParams = [...formData.optionalParameters];
                                    newParams[index].type = detail.selectedOption.value as "header" | "query" | "path";
                                    setFormData({...formData, optionalParameters: newParams});
                                }}
                            />
                            {formData.optionalParameters.length > 0 && (
                                <Button
                                    iconName="remove"
                                    ariaLabel="Remove optional"
                                    variant="icon"
                                    onClick={() => {
                                        const newParams = [...formData.optionalParameters];
                                        newParams.splice(index, 1);
                                        setFormData({...formData, optionalParameters:newParams});
                                    }}
                                />
                            )}
                        </SpaceBetween>
                    ))}
                </FormField>


            </SpaceBetween>
        </Container>
    );
};

export default APIParametersSection;
